module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921124149_T.2e3d3948.jpg";